import { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppUserContext } from '../../App';
import { ErrorLoading } from '../../components/loading';
import ViewRates from './view-rates';

const VehicleRates = () => {

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level !== 1) {
        return <ErrorLoading>You do not have the permission to view/add/edit financial accounts.</ErrorLoading>
    }


    return (
        <Routes>
            <Route path="/" element={<ViewRates />} />
        </Routes>
    )
};

export default VehicleRates;